module.exports = __webpack_public_path__ + "static/media/all-down-tonight-clip.a9a0d9a9.mp3";